(() => {
  const name = 'subscriptions';

  TrackApp[name] = (() => {
    const fillSubscriptionInfo = (p) => {
      if (p.isSubscriptionProduct) {
        /* eslint-disable no-param-reassign */
        p.details = p.details || {};
        p.details.subscription = { ...ua.info.subscriptionInOrder };
        /* eslint-enable no-param-reassign */
      }
    };

    const groupTheSameAnalyticsProducts = (products) => {
      const groupedProducts = [];

      products.forEach((p) => {
        const sameProduct = groupedProducts.filter((gp) => (
          gp.isSubscriptionProduct === p.isSubscriptionProduct
          && (p.category === App.product.Type.LENS
            ? gp.packageSKU === p.packageSKU
            : gp.productId === p.productId)
        ))[0];
        if (sameProduct) {
          sameProduct.inCartQuantity += p.inCartQuantity;
        } else {
          groupedProducts.push(p);
        }
      });
      return groupedProducts;
    };

    const setAnalyticsInfo = (subscriptionInOrder) => {
      ua.info.subscriptionInOrder = { ...subscriptionInOrder };
      ua.info.productInformation.forEach(fillSubscriptionInfo);
      if (ua.thanks) {
        ua.info.productInformation = groupTheSameAnalyticsProducts(ua.info.productInformation);
        ua.prodInfo = ua.info.productInformation;
      }
    };

    return {
      setAnalyticsInfo,
    };
  })();
})();
